import Header from '../common/components/header/Header'
import { useCompetitionId } from '../common/hooks'
import Meta from '../common/Meta'
import { useCompetitionDetails } from '../navigation/api'
import classes from './Ladder.module.css'
import MatchesLadder from './MatchesLadder'
import RacesLadder from './RacesLadder'

export default function LeagueLadderLayout() {
  const competition_id = useCompetitionId()
  const { data: competitionDetails } = useCompetitionDetails({
    competition_id: competition_id,
  })

  return (
    <div className={classes.container}>
      <Meta title="League Ladder" />
      <Header title="League Ladder" withUpdate />

      {competitionDetails && competitionDetails.kind === 'match' ? (
        <MatchesLadder competition_id={competition_id} />
      ) : (
        <RacesLadder competition_id={competition_id} />
      )}
    </div>
  )
}
